import { useState, useContext } from 'react';
import router from 'next/router';
import PostAJobFormComponent from '../PostAJobFormComponent/PostAJobFormComponent';
import {
  Container,
  StepsWrapper,
  Title,
  Subtitle,
  StepsDiv,
  StyledDivWrapper,
  StyledDiv,
  ButtonWrapper,
  Arrow,
  BackArrow,
} from './PostAJobMainContent.styles';
import Button from '../Button/Button';
import { DeviceContext, PostAJobContext } from '@/utils/context';
import { COMPANY, JOB, CHECKOUT } from '@/utils/constants';

const PostAJobMainContent = () => {
  const [currentStep, setCurrentStep] = useState(COMPANY);
  const [isSend, setIsSend] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const isMobile = useContext(DeviceContext);

  const [isCompanyReady, setIsCompanyReady] = useState(false);
  const [isJobReady, setIsJobReady] = useState(false);
  const [isCheckoutReady, setIsCheckoutReady] = useState(false);

  if (isSend && isSuccess) {
    return (
      <StyledDivWrapper>
        <StyledDiv>
          <Title>Thanks for your application!</Title>
          <Subtitle>
            We will check your post as soon as possible and update you about its
            status on your email
          </Subtitle>
          <ButtonWrapper>
            <Button clickHandler={() => router.push(`/`)}>
              Go to Home Page
            </Button>
          </ButtonWrapper>
        </StyledDiv>
      </StyledDivWrapper>
    );
  }

  if (isSend && !isSuccess) {
    return (
      <StyledDivWrapper>
        <StyledDiv>
          <Title>Sorry!</Title>
          <Subtitle>An unexpected error has occurred</Subtitle>
          <ButtonWrapper>
            <Button clickHandler={() => router.push(`/`)}>
              Go to Home Page
            </Button>
          </ButtonWrapper>
        </StyledDiv>
      </StyledDivWrapper>
    );
  }

  return (
    <PostAJobContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        setIsCompanyReady,
        setIsJobReady,
        setIsCheckoutReady,
        setIsSend,
        setIsSuccess,
      }}
    >
      <Container>
        <Title>
          Post a Job
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/image-1.png"
            alt="laptop-icon"
            width="24px"
            height="24px"
            loading="lazy"
          />
        </Title>
        <Subtitle>
          Only a few steps away from finding your next Engineer
        </Subtitle>
        <StepsWrapper>
          <StepsDiv
            isReady={isCompanyReady}
            isCurrentStep={currentStep === COMPANY}
          >
            <Arrow />
            {isMobile
              ? currentStep === COMPANY
                ? `Company Details`
                : `1`
              : `Company Details`}
          </StepsDiv>
          <StepsDiv isReady={isJobReady} isCurrentStep={currentStep === JOB}>
            <Arrow />
            {isMobile
              ? currentStep === JOB
                ? `Job Details`
                : `2`
              : `Job Details`}
            <BackArrow>
              <div />
              <div />
              <div />
            </BackArrow>
          </StepsDiv>
          <StepsDiv
            isReady={isCheckoutReady}
            isCurrentStep={currentStep === CHECKOUT}
          >
            {isMobile
              ? currentStep === CHECKOUT
                ? `Checkout`
                : `3`
              : `Checkout`}
            <BackArrow>
              <div />
              <div />
              <div />
            </BackArrow>
          </StepsDiv>
        </StepsWrapper>
        <PostAJobFormComponent />
      </Container>
    </PostAJobContext.Provider>
  );
};

export default PostAJobMainContent;
